// extracted by mini-css-extract-plugin
export default {"products":"pw-z","card":"qw-z","oosMessaging":"rw-z"};